import { SORT_BASE_OPTIONS } from './constants/sorts'
import filterSortsByValue from './filterSortsByValue'

const retailerSorts = (sortOptionsConfig: string[]) => {
  const sortOptions = SORT_BASE_OPTIONS.concat(sortOptionsConfig)

  const sortOptionsFiltered = filterSortsByValue(sortOptions)

  return sortOptionsFiltered
}

export default retailerSorts
